<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title><mat-icon>link</mat-icon>External Links</mat-card-title>
      @if (userCanEdit) {
        <button (click)="editToggle()" class="edit-btn" [matTooltip]="isEditMode ? 'Close' : 'Edit external links'">@if (!isEditMode) {
          <mat-icon>edit</mat-icon>
          }@if (isEditMode) {
          <mat-icon>close</mat-icon>
        }</button>
      }
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    @if (!isEditMode) {
      <div>
        @if (filesLinks.length==0) {
          <div class="no-data">There are currently no external links for this event</div>
        }
        @if (filesLinks.length>0) {
          <div class="row">
            @for (link of filesLinks; track link) {
              <div class="col-md-12">
                <span class="inline-file"><mat-icon class="link-icon">link</mat-icon>@if (link.name!==null) {
                <mat-label class="link-label">{{link.name}}: </mat-label>
                }<a  class="site-hyperlink" href="{{link.path}}" target="_blank">{{link.path}}</a></span>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (isEditMode) {
      <div>
        @if (filesLinks.length>0) {
          <div>
            @for (link of filesLinks; track link) {
              <div class="row align-top">
                <span class="inline-file-edit">@if (link.name!==null) {
                  <mat-label class="link-label">{{link.name}}: </mat-label>
                  }<a class="site-hyperlink" href="{{link.path}}" target="_blank">{{link.path}}</a><button (click)="deleteWebLink(link)" matTooltip="Remove link/file" class="delete-link-btn"><mat-icon>delete</mat-icon></button><button matTooltip="Edit link" (click)="editWeblink(link)" class="delete-link-btn"><mat-icon>edit</mat-icon></button></span>
                </div>
              }
            </div>
          }
          <div class="row align-top">
            <form [formGroup]="linkForm">
              <span>
                <mat-form-field class="input-label">
                  <input matInput placeholder="Label (optional)" formControlName="label" name="label" type="text" />
                </mat-form-field>
                <mat-form-field>
                  <input matInput [placeholder]="'https://www.creallc.com'" formControlName="link" name="link" type="text" />
                </mat-form-field>
                <button mat-mini-fab class="add-link-btn" [matTooltip]="isEditingLink ? 'Update link' : 'Save link'" (click)="addExternalLink()">
                  <mat-icon>save</mat-icon>
                </button>
              </span>
            </form>
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
